import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ESupportTicketSource } from "../../aiTickets.types";

const ROUTE_BY_SOURCE: Record<ESupportTicketSource, string> = {
  [ESupportTicketSource.WhatsApp]: "admin/whatsapp-bot/conversations",
  [ESupportTicketSource.InAppSupport]: "admin/in-app-support/conversations",
};

export const requestSendTicketMessage = async ({
  source,
  conversationId,
  text,
  imageUrl,
  audioUrl,
}: {
  source: ESupportTicketSource;
  conversationId: string;
  text?: string;
  imageUrl?: string;
  audioUrl?: string;
}): Promise<unknown> =>
  await instance.post(
    buildUrl(ROUTE_BY_SOURCE[source], conversationId, "messages"),
    { text, imageUrl, audioUrl },
  );

export const requestSetTicketConversationMode = async ({
  source,
  conversationId,
  mode,
}: {
  source: ESupportTicketSource;
  conversationId: string;
  mode: "ai" | "human";
}): Promise<unknown> =>
  await instance.patch(
    buildUrl(ROUTE_BY_SOURCE[source], conversationId, "mode"),
    { mode },
  );
